module.exports = __webpack_public_path__ + "img/default.ba7365ca.jpg";